export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq60_sell.172508a8.mp3";